import React, { useEffect, useState } from "react";
import { Moon, Sun, Monitor } from "lucide-react";
import { applyProgereTheme, getThemePreference } from "@/services/progereTheme";

const ORDER = ["dark", "light", "system"];
const META = {
  dark: { icon: Moon, label: "Mode sombre" },
  light: { icon: Sun, label: "Mode clair" },
  system: { icon: Monitor, label: "Système" },
};

export function ProgereThemeSwitcher() {
  const [pref, setPref] = useState(getThemePreference);
  useEffect(() => { applyProgereTheme(pref); }, [pref]);
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const h = () => { if (getThemePreference() === "system") applyProgereTheme("system"); };
    mq.addEventListener("change", h);
    return () => mq.removeEventListener("change", h);
  }, []);
  const next = () => setPref((p) => ORDER[(ORDER.indexOf(p) + 1) % ORDER.length]);
  const { icon: Icon, label } = META[pref] || META.dark;
  return (
    <button onClick={next} data-testid="theme-switcher" aria-label={`Thème : ${label}`} title={`Thème : ${label} (cliquer pour changer)`}
      className="text-gray-400 hover:text-[#F2BC2E] transition-colors flex items-center">
      <Icon size={18} />
    </button>
  );
}
